import React, { useEffect } from "react";
import { Alert } from "../../Components/Alert";
import Consultant from "../../Components/Consultant";
import { ConsultantSkeleton } from "../../Components/ConsultantSkeleton";
import {
  requestListConsultant,
  useConsultantDispatch,
  useConsultantState,
} from "../../Context";
import { EmptyList } from "../../Components/EmptyList";

export const ConsultantList = () => {
  const dispatch = useConsultantDispatch();
  const { consultants, error, loading } = useConsultantState();

  useEffect(() => {
    requestListConsultant(dispatch);
  }, [dispatch]);

  return (
    <div className="max-w-7xl">
      {error && (
        <Alert
          type="error"
          message={error?.message || "Error fetching consultant list."}
          errors={error?.errors}
        />
      )}
      {loading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 animate-pulse">
          <ConsultantSkeleton />
          <ConsultantSkeleton />
          <ConsultantSkeleton />
        </div>
      ) : consultants.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
          {consultants.map((consultant) => (
            <a
              key={consultant.id}
              href={`/consultant/${consultant.id}`}
              className="block hover:no-underline focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-xl"
            >
              <Consultant consultant={consultant} />
            </a>
          ))}
        </div>
      ) : (
        <EmptyList title="consultantUnavailable" />
      )}
    </div>
  );
};
